<template>
    <div>
        <el-button :disabled="loading" type="primary" @click="openDialog()">新建</el-button>
    </div>
    <el-table v-loading="loading" :data="data" style="margin-top: 20px">
        <el-table-column label="ID" width="150" prop="id"></el-table-column>
        <el-table-column label="活跃" width="80" prop="active">
            <template #default="scope">
                <el-switch v-model="scope.row.active" :disabled="loading" @change="update(scope.row)"></el-switch>
            </template>
        </el-table-column>
        <el-table-column label="封面" width="150" prop="cover">
            <template #default="scope">
                <el-image style="width: 140px" lazy
                          :src="`${$root.env.CDN_URL}/${scope.row.cover}`"></el-image>
            </template>
        </el-table-column>
        <el-table-column label="icon" width="100" prop="icon">
            <template #default="scope">
                <el-image style="width: 60px" lazy
                          :src="`${$root.env.CDN_URL}/${scope.row.icon}`"></el-image>
            </template>
        </el-table-column>
        <el-table-column label="主题色" width="100" prop="color"></el-table-column>
        <el-table-column label="名称" width="150" prop="i18n_name.EN"></el-table-column>
        <el-table-column label="描述" width="200" prop="i18n_desc.EN"></el-table-column>
        <el-table-column label="操作" width="250">
            <template #default="scope">
                <el-button type="success" circle icon="Top" :loading="loading"
                           :disabled="scope.$index===0" @click="moveUp(scope.$index)"></el-button>
                <el-button type="success" circle icon="Bottom" :loading="loading"
                           :disabled="scope.$index===data.length - 1" @click="moveDown(scope.$index)"></el-button>
                <el-button size="small" :disabled="loading" @click="openDialog(scope.row)">编辑</el-button>
                <el-button size="small" type="success" :disabled="loading" @click="$refs.image.openDialog(scope.row)">
                    内容
                </el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-dialog v-model="dialog_opened" :before-close="reset" :close-on-click-modal="false">
        <el-form ref="form" :model="form" label-width="120px">
            <el-form-item :label="`${k}名称`" v-for="(_, k) in form.i18n_name" :prop="`i18n_name.${k}`"
                          :rules="k==='EN'?[{required: true, message: `请输入${k}名称`}]:null">
                <el-input v-model="form.i18n_name[k]" :disabled="loading"></el-input>
            </el-form-item>
            <el-divider></el-divider>
            <el-form-item :label="`${k}描述`" v-for="(_, k) in form.i18n_desc" :prop="`i18n_desc.${k}`"
                          :rules="k==='EN'?[{required: true, message: `请输入${k}描述`}]:null">
                <el-input v-model="form.i18n_desc[k]" :disabled="loading"></el-input>
            </el-form-item>
            <el-divider></el-divider>
            <el-form-item label="主题色" prop="color" :rules="[{required: true, validator}]">
                <el-color-picker v-model="form.color" :disabled="loading"></el-color-picker>
                <el-input v-model="form.color" :disabled="loading"
                          style="width: 100px;display: inline-block;margin-left: 20px"></el-input>
            </el-form-item>
            <el-form-item label="封面" prop="cover" :rules="[{required: true, message: '请上传封面'}]">
                <el-upload action="/cms/v1/resource" :show-file-list="false" :onSuccess="handleSuccess('cover')"
                           accept="image/*" :data="{prefix: 'event'}" :onProgress="handleProgress"
                           :headers="{authorization: $root.authorization}">
                    <img v-if="form.cover" :src="`${$root.env.CDN_URL}/${form.cover}`" style="width: 200px">
                    <el-button size="small" v-else :loading="loading">上传</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item label="首页横幅" prop="banner" :rules="[{required: true, message: '请上传首页横幅'}]">
                <el-upload action="/cms/v1/resource" :show-file-list="false" :onSuccess="handleSuccess('banner')"
                           accept="image/*" :data="{prefix: 'event'}" :onProgress="handleProgress"
                           :headers="{authorization: $root.authorization}">
                    <img v-if="form.banner" :src="`${$root.env.CDN_URL}/${form.banner}`" style="width: 100px">
                    <el-button size="small" v-else :loading="loading">上传</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item label="结束时间" prop="close" :rules="[{required: true, message: '请选择活动结束时间'}]">
                <el-date-picker v-model="form.close" value-format="YYYY-MM-DD" :disabled="loading"></el-date-picker>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button type="primary" :loading="loading" text @click="reset">取消</el-button>
            <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
        </template>
    </el-dialog>
    <collection-event-image ref="image"></collection-event-image>
</template>

<script>
import axios from 'ts-axios-new';
import {update} from "../../libs/utils";
import CollectionEventImage from "./CollectionEventImage";

export default {
    name: "CollectionEvent",
    components: {CollectionEventImage},
    data() {
        return {
            loading: false, data: [], editing: false, dialog_opened: false,
            form: {
                i18n_name: {
                    EN: '',
                    FR: '',
                    HI: '',
                    IT: '',
                    AR: '',
                    ES: '',
                    PT: '',
                    DE: '',
                    EL: '',
                    ZH_HANS: '',
                    ZH_HANT: '',
                    ID: '',
                    KO: '',
                    TH: '',
                    NL: '',
                    TR: '',
                    PL: '',
                    VI: '',
                    FI: '',
                    RU: '',
                    HU: '',
                    JA: '',
                    NO: '',
                    SV: '',
                    UK: '',
                    MS: '',
                    IW: '',
                    RO: '',
                    TL: '',
                },
                i18n_desc: {
                    EN: '',
                    FR: '',
                    HI: '',
                    IT: '',
                    AR: '',
                    ES: '',
                    PT: '',
                    DE: '',
                    EL: '',
                    ZH_HANS: '',
                    ZH_HANT: '',
                    ID: '',
                    KO: '',
                    TH: '',
                    NL: '',
                    TR: '',
                    PL: '',
                    VI: '',
                    FI: '',
                    RU: '',
                    HU: '',
                    JA: '',
                    NO: '',
                    SV: '',
                    UK: '',
                    MS: '',
                    IW: '',
                    RO: '',
                    TL: '',
                },
                cover: '',
                banner: '',
                color: null,
                close: null,
                active: false,
            },
        }
    },
    methods: {
        init() {
            this.loading = true;
            axios.get('/cms/v1/collection-event').then(res => {
                this.data = res.data.data.eventList;
                this.loading = false;
            });
        },
        openDialog(item) {
            this.dialog_opened = true;
            this.$nextTick(_ => {
                if (item) {
                    update(this.form, item);
                    this.editing = item;
                }
            })
        },
        reset() {
            this.$refs.form.resetFields();
            this.dialog_opened = this.loading = false;
            this.editing = null;
            this.form.i18n_desc = {
                EN: '',
                FR: '',
                HI: '',
                IT: '',
                AR: '',
                ES: '',
                PT: '',
                DE: '',
                EL: '',
                ZH_HANS: '',
                ZH_HANT: '',
                ID: '',
                KO: '',
                TH: '',
                NL: '',
                TR: '',
                PL: '',
                VI: '',
                FI: '',
                RU: '',
                HU: '',
                JA: '',
                NO: '',
                SV: '',
                UK: '',
                MS: '',
                IW: '',
                RO: '',
                TL: '',
            };
            this.form.i18n_name = {
                EN: '',
                FR: '',
                HI: '',
                IT: '',
                AR: '',
                ES: '',
                PT: '',
                DE: '',
                EL: '',
                ZH_HANS: '',
                ZH_HANT: '',
                ID: '',
                KO: '',
                TH: '',
                NL: '',
                TR: '',
                PL: '',
                VI: '',
                FI: '',
                RU: '',
                HU: '',
                JA: '',
                NO: '',
                SV: '',
                UK: '',
                MS: '',
                IW: '',
                RO: '',
                TL: '',
            }
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.loading = true;
                    if (this.editing) {
                        axios.put(`/cms/v1/collection-event/${this.editing.id}`, this.form).then(res => {
                            update(this.editing, res.data.data);
                            this.reset();
                        })
                    } else {
                        axios.post(`/cms/v1/collection-event`, this.form).then(res => {
                            this.data.unshift(res.data.data);
                            this.reset();
                        });
                    }
                }
            })
        },
        validator(rule, value, callback) {
            if (/^#[A-Z0-9]{6}$/.test(value)) {
                callback();
            } else {
                callback('请选择或输入正确格式的颜色码');
            }
        },
        handleSuccess(name) {
            return res => {
                this.loading = false;
                this.form[name] = res.data.name
            }
        },
        handleProgress() {
            this.loading = true;
        },
        update(row) {
            this.loading = true;
            axios.put(`/cms/v1/collection-event/${row.id}`, row).then(_ => {
                this.loading = false;
            })
        },
        moveUp(index) {
            const row = this.data.splice(index, 1);
            this.data.splice(index - 1, 0, row[0]);
            this.resort();
        },
        moveDown(index) {
            const row = this.data.splice(index, 1);
            this.data.splice(index + 1, 0, row[0]);
            this.resort();
        },
        sort() {
            const sort = [];
            this.data.forEach(d => {
                sort.push(d.id);
            })
            this.loading = true;
            axios.post(`/cms/v1/sort/collection-event`, {sort}).then(_ => {
                this.loading = false;
            })
        },
    },
    mounted() {
        this.init();
    }
}
</script>

<style scoped>

</style>